import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3ae97161")

_pushScopeId("data-v-3ae97161")
const _hoisted_1 = { class: "overlay digest-circle" }
const _hoisted_2 = { class: "digest-circle__chart" }
const _hoisted_3 = {
  id: "digestCircle",
  ref: "canvasElem"
}
const _hoisted_4 = { class: "digest-circle__labels" }
const _hoisted_5 = { class: "digest-circle__text" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("canvas", _hoisted_3, null, 512)
    ]),
    _createVNode("div", _hoisted_4, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.filteredFrequentlyReports, (elem, elemInd) => {
        return (_openBlock(), _createBlock("div", {
          key: elemInd,
          class: "digest-circle__label"
        }, [
          _createVNode("div", {
            class: "digest-circle__color",
            style: { backgroundColor: $setup.getColor(elem.id) }
          }, null, 4),
          _createVNode("div", _hoisted_5, _toDisplayString($setup.getName(elem)), 1)
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
})